<template>
  <v-container fluid class="pa-8">
    <v-row>
      <v-col>
        <h2>Permissions / RBAC</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-select
          v-model="selectedRole"
          :items="roles"
          label="Role"
          clearable
          density="compact"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-alert v-if="error" type="error" dense>
          読み込みに失敗しました（権限が無い場合は403になります）
        </v-alert>

        <v-progress-linear v-if="loading" indeterminate />

        <v-data-table
          v-if="!loading && filteredItems.length"
          :headers="headers"
          :items="filteredItems"
          :sort-by="sortBy"
          multi-sort
          must-sort
          :items-per-page="50"
          class="elevation-1"
          dense
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createDeveloperPermissionsActions } from "@/vue/features/developer-permissions";

export default {
  name: "DeveloperPermissionsPage",
  data() {
    return {
      loading: false,
      error: false,
      actions: null,
      roles: [],
      items: [],
      permissionRows: [],
      selectedRole: null
    };
  },
  computed: {
    headers() {
      const base = [
        { title: "permission_key", key: "permission_key", value: "permission_key" },
        { title: "entrypoint", key: "entrypoint", value: "entrypoint" },
        { title: "required_entitlements", key: "required_entitlements", value: "required_entitlements" },
        { title: "required_context_keys", key: "required_context_keys", value: "required_context_keys" },
        { title: "required_credentials_keys", key: "required_credentials_keys", value: "required_credentials_keys" }
      ];

      const roleHeaders = (this.roles || []).map((r) => ({
        title: r,
        key: `role_${r}`,
        value: `role_${r}`
      }));

      return [...base, ...roleHeaders];
    },
    filteredItems() {
      if (!this.selectedRole) return this.items || [];
      return (this.items || []).filter((i) => !!i.roles_allowed?.[this.selectedRole]);
    },
    sortBy() {
      return [
        { key: "entrypoint_rank", order: "asc" },
        { key: "permission_key", order: "asc" }
      ];
    }
  },
  created() {
    this.actions = createDeveloperPermissionsActions();
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      this.error = false;
      try {
        const matrix = await this.actions.fetchMatrix();
        if (!matrix) throw new Error("matrix is null");

        this.roles = matrix.roles || [];
        this.permissionRows = matrix.permissions || [];

        this.items = (matrix.permissions || []).map((p) => {
          const roleCols = {};
          (matrix.roles || []).forEach((r) => {
            const allowed = !!p.roles_allowed?.[r];
            roleCols[`role_${r}`] = allowed ? "allow" : "deny";
          });

          return {
            permission_key: p.permission_key,
            entrypoint: p.entrypoint,
            entrypoint_rank: this.entrypointRank(p.entrypoint),
            required_entitlements: (p.required_entitlements || []).join(", "),
            required_context_keys: (p.required_context_keys || []).join(", "),
            required_credentials_keys: (p.required_credentials_keys || []).join(", "),
            roles_allowed: p.roles_allowed || {},
            ...roleCols
          };
        });
      } catch (e) {
        console.log(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    entrypointRank(entrypoint) {
      switch (String(entrypoint)) {
      case "public":
        return 0;
      case "api_key":
        return 1;
      case "login_required":
        return 2;
      default:
        return 99;
      }
    }
  }
};
</script>
